"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_1 = require("mobx");
var Payments_1 = require("./Payments");
var CartDiscountBaseLine_1 = require("./Discount/CartDiscountBaseLine");
var DiscountTypes;
(function (DiscountTypes) {
    DiscountTypes["FIXED"] = "fixed";
    DiscountTypes["PERCENT"] = "percent";
})(DiscountTypes = exports.DiscountTypes || (exports.DiscountTypes = {}));
var DiscountModes;
(function (DiscountModes) {
    DiscountModes[DiscountModes["ALL_PRODUCTS_AND_CATEGORIES"] = 0] = "ALL_PRODUCTS_AND_CATEGORIES";
    DiscountModes[DiscountModes["SPECIFIC_PRODUCTS"] = 1] = "SPECIFIC_PRODUCTS";
    DiscountModes[DiscountModes["SPECIFIC_CATEGORIES"] = 2] = "SPECIFIC_CATEGORIES";
    DiscountModes[DiscountModes["NO_DISCOUNT"] = 3] = "NO_DISCOUNT";
})(DiscountModes = exports.DiscountModes || (exports.DiscountModes = {}));
var ApplyTypes;
(function (ApplyTypes) {
    ApplyTypes["CART"] = "cart";
    ApplyTypes["PRODUCTS"] = "products";
    ApplyTypes["BUNDLE"] = "bundle";
})(ApplyTypes = exports.ApplyTypes || (exports.ApplyTypes = {}));
var CreateOrEditDiscount = /** @class */ (function () {
    function CreateOrEditDiscount(discount) {
        var _this = this;
        this.name = '';
        this.description = '';
        this.type = DiscountTypes.PERCENT;
        this.applyType = 'products';
        this.amount = 0;
        this.loyaltyTierId = null;
        this.locationIds = [];
        this.products = [];
        this.categories = [];
        this.brands = [];
        this.loyaltyCost = 0;
        this.setName = function (name) {
            _this.name = name;
        };
        this.setDescription = function (description) {
            _this.description = description;
        };
        this.setApplyType = function (applyType) {
            _this.applyType = applyType;
        };
        this.setAutomaticDiscount = function (bool) {
            _this.automatic = bool;
        };
        this.setIsLoyaltyDiscount = function (isLoyalty) {
            _this.isLoyalty = isLoyalty;
        };
        this.setLoyaltyCost = function (loyaltyCost) {
            _this.loyaltyCost = loyaltyCost;
        };
        this.set(discount);
    }
    CreateOrEditDiscount.prototype.setLoyaltyTierId = function (id) {
        this.loyaltyTierId = id;
    };
    CreateOrEditDiscount.prototype.set = function (discount) {
        if (discount) {
            Object.assign(this, discount);
            this.products = this.products.map(function (p) { return Object.assign(new DiscountProduct(), p); });
            this.categories = this.categories.map(function (c) { return Object.assign(new DiscountCategory(), c); });
            this.brands = this.brands.map(function (s) { return Object.assign(new DiscountBrand(), s); });
        }
    };
    CreateOrEditDiscount.prototype.addProductWithData = function (data) {
        this.products = __spread(this.products, [data]);
    };
    CreateOrEditDiscount.prototype.removeProduct = function (index) {
        this.products.splice(index, 1);
    };
    CreateOrEditDiscount.prototype.addCategoryWithData = function (data) {
        this.categories = __spread(this.categories, [data]);
    };
    CreateOrEditDiscount.prototype.removeCategory = function (index) {
        this.categories.splice(index, 1);
    };
    CreateOrEditDiscount.prototype.setLocationIds = function (ids) {
        this.locationIds = ids;
    };
    CreateOrEditDiscount.prototype.toggleApplyDateRestriction = function () {
        this.applyDateRestriction = !this.applyDateRestriction;
        this.toggleIsRecurring();
        this.isRecurring = false;
        this.startTime = null;
        this.endTime = null;
    };
    CreateOrEditDiscount.prototype.toggleIsRecurring = function () {
        this.isRecurring = !this.isRecurring;
        this.sunday = false;
        this.monday = false;
        this.tuesday = false;
        this.wednesday = false;
        this.thursday = false;
        this.friday = false;
        this.saturday = false;
        this.startDate = null;
        this.endDate = null;
    };
    CreateOrEditDiscount.prototype.sanitize = function () {
        var sanitizedProducts = this.products.filter(function (product) { return product.id; });
        var sanitizedCategories = this.categories.filter(function (category) { return category.id; });
        this.products = sanitizedProducts;
        this.categories = sanitizedCategories;
    };
    CreateOrEditDiscount.prototype.removeAllCategories = function () {
        this.categories = [];
    };
    CreateOrEditDiscount.prototype.removeAllProducts = function () {
        this.products = [];
    };
    Object.defineProperty(CreateOrEditDiscount.prototype, "isValid", {
        get: function () {
            var valid = true;
            if (!this.name) {
                valid = false;
            }
            this.products.forEach(function (p) {
                if (!p.id) {
                    valid = false;
                }
            });
            this.categories.forEach(function (c) {
                if (!c.id) {
                    valid = false;
                }
            });
            return valid;
        },
        enumerable: true,
        configurable: true
    });
    __decorate([
        mobx_1.observable
    ], CreateOrEditDiscount.prototype, "id", void 0);
    __decorate([
        mobx_1.observable
    ], CreateOrEditDiscount.prototype, "name", void 0);
    __decorate([
        mobx_1.observable
    ], CreateOrEditDiscount.prototype, "description", void 0);
    __decorate([
        mobx_1.observable
    ], CreateOrEditDiscount.prototype, "type", void 0);
    __decorate([
        mobx_1.observable
    ], CreateOrEditDiscount.prototype, "applyType", void 0);
    __decorate([
        mobx_1.observable
    ], CreateOrEditDiscount.prototype, "amount", void 0);
    __decorate([
        mobx_1.observable
    ], CreateOrEditDiscount.prototype, "loyaltyTierId", void 0);
    __decorate([
        mobx_1.observable
    ], CreateOrEditDiscount.prototype, "locationIds", void 0);
    __decorate([
        mobx_1.action
    ], CreateOrEditDiscount.prototype, "setLoyaltyTierId", null);
    __decorate([
        mobx_1.observable
    ], CreateOrEditDiscount.prototype, "products", void 0);
    __decorate([
        mobx_1.observable
    ], CreateOrEditDiscount.prototype, "categories", void 0);
    __decorate([
        mobx_1.observable
    ], CreateOrEditDiscount.prototype, "brands", void 0);
    __decorate([
        mobx_1.observable
    ], CreateOrEditDiscount.prototype, "applyDateRestriction", void 0);
    __decorate([
        mobx_1.observable
    ], CreateOrEditDiscount.prototype, "isRecurring", void 0);
    __decorate([
        mobx_1.observable
    ], CreateOrEditDiscount.prototype, "sunday", void 0);
    __decorate([
        mobx_1.observable
    ], CreateOrEditDiscount.prototype, "monday", void 0);
    __decorate([
        mobx_1.observable
    ], CreateOrEditDiscount.prototype, "tuesday", void 0);
    __decorate([
        mobx_1.observable
    ], CreateOrEditDiscount.prototype, "wednesday", void 0);
    __decorate([
        mobx_1.observable
    ], CreateOrEditDiscount.prototype, "thursday", void 0);
    __decorate([
        mobx_1.observable
    ], CreateOrEditDiscount.prototype, "friday", void 0);
    __decorate([
        mobx_1.observable
    ], CreateOrEditDiscount.prototype, "saturday", void 0);
    __decorate([
        mobx_1.observable
    ], CreateOrEditDiscount.prototype, "startDate", void 0);
    __decorate([
        mobx_1.observable
    ], CreateOrEditDiscount.prototype, "endDate", void 0);
    __decorate([
        mobx_1.observable
    ], CreateOrEditDiscount.prototype, "startTime", void 0);
    __decorate([
        mobx_1.observable
    ], CreateOrEditDiscount.prototype, "endTime", void 0);
    __decorate([
        mobx_1.observable
    ], CreateOrEditDiscount.prototype, "automatic", void 0);
    __decorate([
        mobx_1.observable
    ], CreateOrEditDiscount.prototype, "isLoyalty", void 0);
    __decorate([
        mobx_1.observable
    ], CreateOrEditDiscount.prototype, "loyaltyCost", void 0);
    __decorate([
        mobx_1.action
    ], CreateOrEditDiscount.prototype, "setName", void 0);
    __decorate([
        mobx_1.action
    ], CreateOrEditDiscount.prototype, "setDescription", void 0);
    __decorate([
        mobx_1.action
    ], CreateOrEditDiscount.prototype, "setApplyType", void 0);
    __decorate([
        mobx_1.action
    ], CreateOrEditDiscount.prototype, "setAutomaticDiscount", void 0);
    __decorate([
        mobx_1.action
    ], CreateOrEditDiscount.prototype, "setIsLoyaltyDiscount", void 0);
    __decorate([
        mobx_1.action
    ], CreateOrEditDiscount.prototype, "addProductWithData", null);
    __decorate([
        mobx_1.action
    ], CreateOrEditDiscount.prototype, "removeProduct", null);
    __decorate([
        mobx_1.action
    ], CreateOrEditDiscount.prototype, "addCategoryWithData", null);
    __decorate([
        mobx_1.action
    ], CreateOrEditDiscount.prototype, "removeCategory", null);
    __decorate([
        mobx_1.action
    ], CreateOrEditDiscount.prototype, "setLocationIds", null);
    __decorate([
        mobx_1.action
    ], CreateOrEditDiscount.prototype, "toggleApplyDateRestriction", null);
    __decorate([
        mobx_1.action
    ], CreateOrEditDiscount.prototype, "toggleIsRecurring", null);
    __decorate([
        mobx_1.action
    ], CreateOrEditDiscount.prototype, "sanitize", null);
    __decorate([
        mobx_1.action
    ], CreateOrEditDiscount.prototype, "removeAllCategories", null);
    __decorate([
        mobx_1.action
    ], CreateOrEditDiscount.prototype, "removeAllProducts", null);
    __decorate([
        mobx_1.action
    ], CreateOrEditDiscount.prototype, "setLoyaltyCost", void 0);
    __decorate([
        mobx_1.computed
    ], CreateOrEditDiscount.prototype, "isValid", null);
    return CreateOrEditDiscount;
}());
exports.CreateOrEditDiscount = CreateOrEditDiscount;
var DiscountProduct = /** @class */ (function () {
    function DiscountProduct() {
        this.type = 'include';
    }
    __decorate([
        mobx_1.observable
    ], DiscountProduct.prototype, "id", void 0);
    __decorate([
        mobx_1.observable
    ], DiscountProduct.prototype, "type", void 0);
    __decorate([
        mobx_1.observable
    ], DiscountProduct.prototype, "name", void 0);
    __decorate([
        mobx_1.observable
    ], DiscountProduct.prototype, "parentProductId", void 0);
    return DiscountProduct;
}());
exports.DiscountProduct = DiscountProduct;
var DiscountCategory = /** @class */ (function () {
    function DiscountCategory() {
        this.type = 'include';
    }
    __decorate([
        mobx_1.observable
    ], DiscountCategory.prototype, "id", void 0);
    __decorate([
        mobx_1.observable
    ], DiscountCategory.prototype, "type", void 0);
    __decorate([
        mobx_1.observable
    ], DiscountCategory.prototype, "name", void 0);
    __decorate([
        mobx_1.observable
    ], DiscountCategory.prototype, "parentCategoryId", void 0);
    __decorate([
        mobx_1.observable
    ], DiscountCategory.prototype, "colorHex", void 0);
    return DiscountCategory;
}());
exports.DiscountCategory = DiscountCategory;
var DiscountBrand = /** @class */ (function () {
    function DiscountBrand() {
        this.type = 'include';
    }
    __decorate([
        mobx_1.observable
    ], DiscountBrand.prototype, "id", void 0);
    __decorate([
        mobx_1.observable
    ], DiscountBrand.prototype, "type", void 0);
    __decorate([
        mobx_1.observable
    ], DiscountBrand.prototype, "name", void 0);
    return DiscountBrand;
}());
exports.DiscountBrand = DiscountBrand;
var CartDiscountLine = /** @class */ (function (_super) {
    __extends(CartDiscountLine, _super);
    function CartDiscountLine(cartDiscountLine, mappedCategories) {
        var _this = _super.call(this, cartDiscountLine, mappedCategories) || this;
        _this.discountId = null;
        _this.setPaymentLines = function (paymentLines) {
            _this.paymentLines = paymentLines;
        };
        _this.setDiscountPrice = function (discountPrice) {
            _this.discountPrice = discountPrice;
        };
        _this.paymentLines = cartDiscountLine.paymentLines;
        _this.productName = cartDiscountLine.productName;
        _this.discountType = cartDiscountLine.discountType;
        _this.discountId = cartDiscountLine.discountId;
        _this.originalDiscountPrice = Math.abs(cartDiscountLine.originalDiscountPrice) * -1;
        _this.discountPrice = Math.abs(cartDiscountLine.discountPrice) * -1;
        _this.discountPercentage = cartDiscountLine.discountPercentage;
        return _this;
    }
    Object.defineProperty(CartDiscountLine.prototype, "networkTransferObject", {
        get: function () {
            return {
                type: this.type,
                productId: null,
                productName: this.productName,
                units: 1,
                unit: 'unit',
                inventorySubtracted: 1,
                price: 0,
                depositFee: null,
                discountId: this.discountId,
                discountPrice: Math.round(this.discountPrice),
                discountMessage: null,
                cartDiscountPrice: 0,
                barcode: null,
                shortDescription: null,
                batchId: null,
                sku: null,
                loyaltyCost: this.loyaltyCost,
                scannedBy: null,
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CartDiscountLine.prototype, "targetMinUnitSold", {
        get: function () {
            if (this.targetedPaymentLines.length === 0)
                return 0;
            return Math.min.apply(Math, __spread(this.targetedPaymentLines.map(function (pl) { return pl.inventorySubtracted; })));
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CartDiscountLine.prototype, "excludedPaymentLines", {
        get: function () {
            var _this = this;
            return this.paymentLines.filter(function (pl) { return (pl.type === Payments_1.PaymentLineType.LOYALTY
                ? false
                : _this.shouldBeExcluded(pl.productId, pl.categoryId)); });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CartDiscountLine.prototype, "targetedPaymentLines", {
        get: function () {
            var _this = this;
            return this.paymentLines.filter(function (pl) { return (pl.type === Payments_1.PaymentLineType.LOYALTY
                ? false
                : _this.shouldBeTargeted(pl.productId, pl.categoryId)); });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CartDiscountLine.prototype, "includedPaymentLines", {
        get: function () {
            var _this = this;
            if (this.isTargetedCartDiscount) {
                return this.targetedPaymentLines;
            }
            return this.paymentLines.filter(function (pl) { return (pl.type === Payments_1.PaymentLineType.LOYALTY
                ? false
                : !_this.shouldBeExcluded(pl.productId, pl.categoryId)); });
        },
        enumerable: true,
        configurable: true
    });
    __decorate([
        mobx_1.observable
    ], CartDiscountLine.prototype, "paymentLines", void 0);
    __decorate([
        mobx_1.observable
    ], CartDiscountLine.prototype, "discountPrice", void 0);
    __decorate([
        mobx_1.action
    ], CartDiscountLine.prototype, "setPaymentLines", void 0);
    __decorate([
        mobx_1.action
    ], CartDiscountLine.prototype, "setDiscountPrice", void 0);
    __decorate([
        mobx_1.computed
    ], CartDiscountLine.prototype, "networkTransferObject", null);
    __decorate([
        mobx_1.computed
    ], CartDiscountLine.prototype, "targetMinUnitSold", null);
    __decorate([
        mobx_1.computed
    ], CartDiscountLine.prototype, "excludedPaymentLines", null);
    __decorate([
        mobx_1.computed
    ], CartDiscountLine.prototype, "targetedPaymentLines", null);
    __decorate([
        mobx_1.computed
    ], CartDiscountLine.prototype, "includedPaymentLines", null);
    return CartDiscountLine;
}(CartDiscountBaseLine_1.CartDiscountBaseLine));
exports.CartDiscountLine = CartDiscountLine;
//# sourceMappingURL=Discount.js.map